<template>
  <div class="OneNews" @click="openNewsModal(onenews.new_id)">
    <div class="img">
      <img :src=" imageLink(onenews.new_image) " />
    </div>
    <div class="data-news">
      <h2>{{ onenews.new_title }}</h2>
      <p class="newsdate">{{ onenews.new_date }}</p>
      <div v-if="onenews.new_article" class="description" v-html="  this.description()+ '...'" ></div>
      <p class="autor">Author: {{ onenews.new_author }}</p>
    </div>
  </div>
</template>

<script>
import eventBus from '@/shared/eventBus.js'
import { baseURL } from '@/api'

export default {
  name: 'OneNews',
  props: {
    onenews: {
      required: true,
      type: Object
    }
  },
  methods: {
    imageLink (image) {
      return baseURL + image
    },
    description () {
      return this.onenews.new_article.substring(0, 300)
    },
    openNewsModal (onenews) {
      let params = {
        modalData: onenews,
        component: 'NewsDescription'
      }
      eventBus.$emit('openModal', params)
    }
  }
}
</script>

<style lang="scss" scoped>
.OneNews{
  text-align: left;
  display:flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  padding: 30px 0px;
  max-width: 1024px;
  margin: 0 auto;
  cursor: pointer;

  .img{
   /* width: 25%; */
    width: 300px;
    height: 200px;
    display: block;
    position: relative;
    overflow: hidden;
    margin-right: 33px;

    img{
    /*  position: absolute;
      top: 0;
      left: 0;
      width: 100%;
*/
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .data-news{
    box-sizing: border-box;
    width:65%;
  }

  h2 {
    line-height: 24px;
    font-family: Ubuntu;
    font-style: normal;
    font-weight: bold;
    font-size: 21px;
    margin-bottom: 5px;
    letter-spacing: 0.06em;
    color: #4B4B4B;
  }

  .newsdate{
    font-family: Ubuntu;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    margin-top:0;
    line-height: 14px;
    letter-spacing: 0.06em;
    color: #9D9D9D;
  }
  .description{
    font-family: Ubuntu;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 22px;
    letter-spacing: 0.02em;
    color: #858585;
  }

  .autor{
    font-family: Ubuntu;
    font-style: normal;
    font-weight: bold;
    font-size: 13px;
    line-height: 15px;
    letter-spacing: 0.06em;
    color: #6A6A6A;
  }
}
</style>
